//我的投资支付弹框
<template>
  <!-- 投资支付 -->
  <el-dialog :title="repayType=='nonAuction'?'协议转让重新支付':repayType=='transactionPrice'?'重新支付成交价款':repayType=='transactionAmount'?'重新支付服务费':''" v-loading.fullscreen.lock="loading" :visible="show" :close-on-click-modal="false" width="60%" @close="close">
<!--    <div>-->
<!--      <div class="h_bg p50" style="margin-top: 0">-->
<!--        <h3>摘牌方式</h3>-->
<!--      </div>-->
<!--      <div class="m50">-->
<!--        <el-radio-group v-model="RepayInfo.payType" disabled>-->
<!--          <el-radio :label="1">全额付款</el-radio>-->
<!--          <el-radio :label="2">预付款</el-radio>-->
<!--          <el-radio :label="3">交付后再付</el-radio>-->
<!--          <el-radio :label="4">其他</el-radio>-->
<!--        </el-radio-group>-->
<!--      </div>-->
<!--    </div>-->
    <div class="transfer_wrap">
      <div class="h_bg p50">
        <h3>转账信息</h3>
        <span>请根据以下银行信息进行缴费，缴费完成后，上传缴费凭证</span>
      </div>
<!--      <div class="demo-input-suffix p50">-->
<!--        <div class="mb10">-->
<!--          <span class="wid">实际支付金额（元）</span>-->
<!--          <span class="redF" v-if="RepayInfo.repayAmount">{{RepayInfo.usePromiseAmount?(RepayInfo.repayAmount*100-RepayInfo.leavePromise*100+(RepayInfo.type==6?0:RepayInfo.transactionAmount*100))/100:(RepayInfo.repayAmount*100+(RepayInfo.type==6?0:RepayInfo.transactionAmount*100))/100}}</span>-->
<!--        </div>-->
<!--        <div class="mb10">-->
<!--          <span class="wid">应支付金额（元）</span>-->
<!--          <span>{{ RepayInfo.repayAmount }}</span>-->
<!--        </div>-->
<!--        <div class="mb10" v-if="data.tranferType == 1">-->
<!--          <span class="wid">交易保证金（元）</span>-->
<!--          <span>{{ RepayInfo.leavePromise }}</span>-->
<!--          <span v-if="RepayInfo.usePromiseAmount" style="display: inline-block; color: #ef5147; padding-left: 30px">已抵扣交易保证金{{ RepayInfo.leavePromise }}元</span>-->
<!--        </div>-->
<!--        <div class="mb10" v-if="RepayInfo.type!=6">-->
<!--          <span class="wid">交易服务费（元）</span>-->
<!--          <span>{{ RepayInfo.transactionAmount }}</span>-->
<!--        </div>-->
<!--      </div>-->
      <div class="p50" v-if="repayType=='nonAuction'">
        <div class="mb10">
          <span class="wid">付款方式</span>
          <span>{{payData.paymentMethod}}</span>
        </div>
        <div class="mb10">
          <span class="wid">成交价款（元）</span>
          <span>{{payData.transactionPrice}}</span>
        </div>
        <div class="mb10">
          <span class="wid">交易服务费（元）</span>
          <span>{{payData.transactionAmount}}</span>
        </div>
        <div class="mb10">
          <span class="wid">应付金额（元）</span>
          <span class="redF">{{payAmount}}</span>
        </div>
      </div>
      <div class="p50" v-if="repayType=='transactionAmount'">
        <div class="mb10">
          <span class="wid">交易服务费（元）</span>
          <span>{{payAmount}}</span>
        </div>
      </div>
      <div class="p50" v-if="repayType=='transactionPrice'">
        <div class="mb10">
          <span class="wid">付款方式</span>
          <span>{{auctionData.paymentMethod}}</span>
        </div>
        <div class="mb10">
          <span class="wid">竞价终价（元）</span>
          <span>{{auctionData.amount}}元{{unitAppend}}</span>
        </div>
        <div class="mb10">
          <span class="wid">成交价款（元）</span>
          <span>{{auctionData.transactionPrice}}</span>
        </div>
        <div class="mb10">
          <span class="wid">应付价款（元）</span>
          <span><span class="red">{{payAmount}}</span><span v-if="auctionData.usePromiseAmount">（<span class="red">保证金抵扣{{auctionData.promiseAmount}}</span>）</span></span>
        </div>
      </div>
      <div class="radio-group-wrap p50">
        <el-radio-group v-model="formData.payStatus">
          <el-radio label="2">自行转账</el-radio>
          <!-- <el-radio label="3">捷算支付</el-radio> -->
<!--           <el-radio label="1">代收代付</el-radio>-->
        </el-radio-group>
      </div>
      <div class="content-group p50">
        <div class="group-tyep" :class="{ active: formData.payStatus == 2 }" v-if="formData.payStatus == 2">
          <el-form ref="formData" label-position="left" size="mini" label-width="100px">
            <el-form-item label="开户银行">{{ openBank }}</el-form-item>
            <el-form-item label="账户名">{{ accountName }}</el-form-item>
            <el-form-item label="账号">{{ bankAccount }}</el-form-item>
          </el-form>
          <div style="margin: 10px 0">
            <div v-for="(item, index) in formData.amountFlowFileList" :key="index">
              <span v-if="item.url" class="imgWrapss">
                <el-image :src="item.url" style="width: 200px; height: 150px"></el-image>
                <i @click.prevent.stop="formData.amountFlowFileList.splice(index, 1);" class="el-icon-delete"></i>
              </span>
            </div>
            <Upload v-model="fileUrl" buttonText="上传缴费凭证（必填)" @fileNameEvt="payFileNameEvt" :size="true"></Upload>
          </div>
        </div>
<!--        <div class="group-tyep" :class="{'active': formData.payStatus == 1,'right-active': formData.payStatus == 1}" v-if="formData.payStatus == 1">-->
<!--          <el-form ref="formData" label-position="left" size="mini">-->
<!--            <el-form-item label="银行账户" prop="bankAccount">-->
<!--              <div class="flex_auto">-->
<!--                <el-select v-model="formData.payBankAccount" @change="changeSelectBank('pay')">-->
<!--                  <el-option v-for="item in bankList" :key="item.bankCard" :label="`${item.bankName}(${item.bankCard.slice(-4)})`" :value="item.bankCard"></el-option>-->
<!--                </el-select>-->
<!--                <el-button @click="$router.push({name:'managementPersonal'})" style="margin-left: 10px;"> 添加银行卡</el-button>-->
<!--              </div>-->
<!--            </el-form-item>-->
<!--            <div>-->
<!--              <el-checkbox v-model="checked"></el-checkbox>-->
<!--              我已阅读，并同意-->
<!--              <el-link v-if="RepayInfo.userType == 1" style="color: rgb(4, 126, 255)" :underline="false" href="http://fdfs.whdev.vpclub.cn/group1/M00/01/2F/wKgACmMiwvCALLMNAAHGsdnGZ4I262.pdf" target="_blank">《个人付款授权协议》</el-link>-->
<!--              <el-link v-else style="color: rgb(4, 126, 255)" :underline="false" href="http://fdfs.whdev.vpclub.cn/group1/M00/01/2F/wKgACmMiwx6AHCjYAAHFqH6Bgu8140.pdf" target="_blank">《企业付款授权协议》</el-link>-->
<!--            </div>-->
<!--          </el-form>-->
<!--        </div>-->
        <!-- <div class="group-tyep" :class="{ active: formData.payStatus == 3 }">
          <el-form ref="formData" label-position="left" label-width="120px" size="mini">
            <el-form-item label="支持以下支付方式：">
              <div class="pay">银行卡支付</div>
              <div class="pay bef">微信支付</div>
              <div class="pay befs">支付宝支付</div>
            </el-form-item>
            <div>
              <el-checkbox v-model="checked"></el-checkbox> 我已阅读，并同意
              <el-link v-if="RepayInfo.userType == 2" style="color: #4f79d0" :underline="false" href="http://fdfs.whdev.vpclub.cn/group1/M00/01/2F/wKgACmMiwx6AHCjYAAHFqH6Bgu8140.pdf" target="_blank">《企业付款授权协议》</el-link>
              <el-link v-if="RepayInfo.userType == 1" style="color: #4f79d0" :underline="false" href="http://fdfs.whdev.vpclub.cn/group1/M00/01/2F/wKgACmMiwvCALLMNAAHGsdnGZ4I262.pdf" target="_blank">《个人付款授权协议》</el-link>
            </div>
            <div style="margin: 20px 0 0">
              <el-button @click="payEvt()" :disabled="formData.payStatus != 3 || (RepayInfo.usePromiseAmount ? RepayInfo.repayAmount - RepayInfo.leavePromise : RepayInfo.repayAmount) == 0 ">点击付款</el-button>
            </div>
          </el-form>
        </div> -->
      </div>
    </div>
    <div slot="footer" class="btn">
      <el-button @click="close">取 消</el-button>
      <el-button class="sumbit" @click="saveAndSubmitBtn()">确认提交</el-button>
    </div>
    <payQrcode :qrUrl.sync="qrUrlData" :id.sync="data.id" @JSpayStatus="confirmpayStatus()" />
    <faceQrcode v-if="qrShow" ref="qr" @notify="notify"></faceQrcode>
     <!-- 转账提示 -->
    <paySure :pay.sync="payInfoSure"  @operateSureEvt="operateSureEvt"> </paySure>
  </el-dialog>
</template>

<script>
import Upload from '@/components/Upload/UpLoad.vue'
import payQrcode from '@/components/payQrcode'
import faceQrcode from '@/components/faceQrcodes/index.vue'
import paySure from '@/components/paySure/index.vue'
export default {
  components: {
    Upload,
    payQrcode,
    faceQrcode,
    paySure,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Object,
      default: {},
    },
    repayType: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      unitTimeOption: {
        '0': '无',
        '1': '年 ',
        '2': '季度 ',
        '3': '月 '
      },
      auctionData: {},
      payData: {},
      payAmount: null,
      qrShow: false, //代收代付人脸识别
      qrUrlData: '', //支付二维码
      payStatus: false, //是否已支付
      loading: false,
      formData: {
        amountFlowFileList: [], //支付凭证
        payStatus: '2',
        payType: 1,
        delistingBaseId: '',
        cloudPayId: '',
        payBankAccount: '',
        payBankName: '',
        areaId: '',
        feeType: '1',
        userType: '',
        callbackId: '',
      },
      RepayInfo: {
        leavePromise: '', //保证金
        payType: '', // 支付方式
        repayAmount: '', //付款金额1 全额付款 2 预付款 3 交付后付款 4 其他
        usePromiseAmount: '', //是否使用保证金
        transactionAmount: 0,
        // amount:'',
        // bankAccount: '',//银行账户
        // usePromiseAmount: '', //是否抵扣保证金
        // promiseAmount: '',//保证金
        // leaveAmount: '',//剩余保证金
        // isAdvancePayment: '',  ///是否可以预付款
        // advancePaymentAmount: '', //预付款金额
        userType: '', //1个人 2企业
      },
      openBank: '',
      accountName: '',
      bankAccount: '',
      fileUrl: '',
      fileNameS: '',
      checked: true,
      diaId: '',
      bankList: [],
      payInfoSure:{
        accountName: '',
        bankAccount: '',
        amount: '',
      },
    }
  },
  watch: {
    fileUrl: {
      handler(newVal, oldVal) {
        if (newVal) {
          this.formData.amountFlowFileList.push({
            url: newVal,
            name: this.fileNameS,
          })
          this.fileUrl = ''
        }
      },
    },
    show: {
      async handler(newVal, oldVal) {
        if (newVal) {
          await this.getCompanyInfo()
          await this.getRepayMoney()
          this.getDetail()
          this.formData = {
            amountFlowFileList: [], //支付凭证
            payStatus: '2',
            payType: 1,
            delistingBaseId: '',
            cloudPayId: '',
            payBankAccount: '',
            payBankName: '',
            areaId: '',
            feeType: '1',
            userType: '',
            callbackId: '',
          }
        }
      },
    },
  },
  computed: {
    unitAppend(){
      if(this.auctionData.bidType==1){
        return  `${((this.auctionData.unitNum=='无'||!this.auctionData.unitNum)?'':'/'+this.auctionData.unitNum)+
        ((this.auctionData.unitTime=='0'||!this.auctionData.unitTime)?'':'/'+this.unitTimeOption[this.auctionData.unitTime])}`
      }else {
        return ''
      }
    }
  },
  methods: {
    //获取缴费信息
    getDetail() {
      this.loading = true
      //协议转让重新支付
      if(this.repayType=='nonAuction'){
        this.$api.my
            .delistingGetDetail({ listingApplyId: this.data.listingApplyId })
            .then((res) => {
              if (res.code === 1000) {
                this.payData = res.data
                this.payAmount = Math.round(this.payData.transactionAmount*100+this.payData.transactionPrice*100)/100
              }
            })
            .finally(() => {
              this.loading = false
            })
      }else {
        this.$api.my
            .myInvestmentBankDetail({ id: this.data.id })
            .then((res) => {
              if (res.code === 1000) {
                this.auctionData = res.data
                //服务费重新支付
                if(this.repayType=='transactionAmount'){
                  this.payAmount = this.auctionData.transactionAmount
                }
                //成交价重新支付
                if(this.repayType=='transactionPrice'){
                   this.payAmount = this.auctionData.usePromiseAmount?Math.round(this.auctionData.transactionPrice*100 - this.auctionData.promiseAmount*100)/100:Number(this.auctionData.transactionPrice)
                }
              }
            })
            .finally(() => {
              this.loading = false
            })
      }

    },
    //代收代付
    changeSelectBank(flag) {
      if (this.bankList && this.bankList.length > 0) {
        if (this.formData.payBankAccount) {
          this.bankList.forEach((item) => {
            if (this.formData.payBankAccount == item.bankCard) {
              this.formData.payBankName = item.bankName
              this.formData.payAccountName = item.accountName;
            }
          })
        }
      } else {
        return this.$message.error(
          '请在页面右上的个人中心-账户管理里面添加银行卡'
        )
      }
    },
    //获取代收代付银行卡
    async getBankList() {
      await this.$api.user
        .getMyCard({
          // type: this.RepayInfo.userType == '2' ? 4 : this.RepayInfo.userType,
        })
        .then((res) => {
          if (res.code == 1000 && res.data && res.data.length) {
            this.bankList = res.data
            this.bankList.forEach((item) => {
              if (item.isDefault == 1) {
                this.formData.payBankAccount = item.bankCard //银行账户 （必填）
                this.formData.payBankName = item.bankName //开户银行
                this.formData.payAccountName = item.accountName;
              }
            })
          }
        })
    },
    //捷算支付
    confirmpayStatus(v) {
      this.payStatus = true
    },
    async payEvt() {
      const params = {
        amount:
          Number(
            this.RepayInfo.usePromiseAmount
              ? this.RepayInfo.repayAmount - this.RepayInfo.leavePromise
              : this.RepayInfo.repayAmount
          ) * 100,
        remarks: '',
        linkId: this.data.id,
        payType: 0,
        areaConfigId: this.data.areaConfigId,
      }
      this.loading = true
      await this.$api.apply
        .perPay(params)
        .then((res) => {
          if (res.code === 1000) {
            this.qrUrlData = res.data
          }
        })
        .catch((error) => {})
        .finally(() => {
          this.loading = false
        })
    },
    //获取付款详情
    getRepayMoney() {
      this.loading = true
      this.$api.my
        .getRepayMoneyCount({ delistingBaseId: this.data.id })
        .then((res) => {
          if (res.code === 1000) {
            this.RepayInfo = res.data
            this.getBankList()
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    payFileNameEvt(v) {
      this.fileNameS = v
    },
    //获取自行转账的相关银行信息
    async getCompanyInfo() {
      await this.$api.my
        .getFeeItem({ areaId: this.data.areaConfigId, feeType: '1' })
        .then((res) => {
          if (res.code === 1000) {
            this.openBank = res.data.bankName
            this.accountName = res.data.accountName
            this.bankAccount = res.data.bankCard
          }
        })
    },
    //支付提交
    saveAndSubmitBtn() {
      if(this.formData.payStatus == 2){
        if (!this.formData.amountFlowFileList || (this.formData.amountFlowFileList && !this.formData.amountFlowFileList.length)) {
          return this.$message.error('请上传缴费凭证')
        }
      }
      if (this.formData.payStatus == 1 && !this.checked)
        return this.$message.error('请阅读并勾选付款协议')
      if (
        this.formData.payStatus == 1 &&
        (!this.formData.payBankAccount || !this.formData.payBankName)
      )
        return this.$message.error('请选择代收代付的银行账户')
      if (
        this.formData.payStatus == 3 &&
        !this.payStatus &&
        (this.RepayInfo.usePromiseAmount
          ? this.RepayInfo.repayAmount - this.RepayInfo.leavePromise
          : this.RepayInfo.repayAmount) > 0
      )
        return this.$message.error('请点击付款按钮进行扫码支付')
      this.formData.delistingBaseId = this.data.id
      this.formData.payType = this.RepayInfo.payType
      this.formData.cloudPayId = this.qrUrlData.id
      this.formData.areaId = this.data.areaConfigId
      this.formData.userType = this.RepayInfo.userType
      if(this.formData.payStatus == 2 && (!this.accountName || !this.bankAccount)) {
          return this.$message.error('当前区域未配置收款银行卡,暂不支持自行转账,请联系管理员')
      } else {
        this.payInfoSure = {
          accountName:  this.accountName,
          bankAccount:  this.bankAccount,
          // amount: Math.round((this.RepayInfo.usePromiseAmount ? this.RepayInfo.repayAmount - this.RepayInfo.leavePromise : this.RepayInfo.repayAmount)*100)/100,
          // amount:this.RepayInfo.usePromiseAmount?(this.RepayInfo.repayAmount*100-this.RepayInfo.leavePromise*100+(this.RepayInfo.type==6?0:this.RepayInfo.transactionAmount*100))/100:(this.RepayInfo.repayAmount*100+(this.RepayInfo.type==6?0:this.RepayInfo.transactionAmount*100))/100
          amount: this.payAmount
        }
      }
    },
    operateSureEvt() {
      if (this.formData.payStatus == 1) {
        this.qrShow = true
        this.$nextTick(()=>{
          this.$refs.qr.sumbit()
        })
      } else {
        this.operateEvt()
      }
    },
    operateEvt() {
      this.loading = true
      this.$api.my
        .payMoney({
          ...this.formData,
          repayType: this.repayType=='nonAuction'?'':this.repayType=='transactionPrice'?'2':this.repayType=='transactionAmount'?'1':''
        })
        .then((res) => {
          if (res.code === 1000) {
            this.$message.success('支付成功')
            this.$emit('diaSccessEvt', false)
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    notify(v) {
      this.qrShow = false
      if (v) {
        this.formData.callbackId = this.$refs.qr.callbackId
        setTimeout(() => {
          this.operateEvt()
        }, 500)
      }
    },
    close() {
      this.$emit('dialogCloses')
    },
  },
  mounted() {},
}
</script>
<style lang="scss" >
.red{
  color: #ef5147;
}
.radio-group-wrap .el-radio-group .el-radio{
  width: 100px !important;
}
.content-group{
  .active.right-active::after {
    left: 200px;
  }
}
.btn {
  text-align: center;
  margin: auto;
  display: block;
}
</style>
